<div class="d-flex flex-column wrapper">
  <div class="d-flex">
    <span class="title">{{title}}</span>
  </div>
  <div class="d-flex flex-row">
    <div class="d-flex flex-g1">
      <div class="circle">
        <div class="outer-circle">
          <div class="inner-circle"></div>
        </div>
      </div>
    </div>
    <div class="d-flex flex-g1 justify-content-end">
      <div class="legend">
        <div class="d-flex flex-column">
          <div class="d-flex align-items-center item ellipsis" *ngFor="let item of list">
            <span class="circle-dot"></span>
            <span class="text">{{item}}</span>
            <span class="percent">- %</span>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="message-popup" *ngIf="messageTitle && messageContent">
    <div class="fallback-title">{{messageTitle}}</div>
    <div>{{messageContent}}</div>
  </div>
</div>




// WEBPACK FOOTER //
// ./src/app/core/achoo-pie-chart-placholder/achoo-pie-chart-placholder.component.html